import { render, staticRenderFns } from "./communityReview.vue?vue&type=template&id=7337fc36&scoped=true"
import script from "./communityReview.vue?vue&type=script&lang=js"
export * from "./communityReview.vue?vue&type=script&lang=js"
import style0 from "./communityReview.vue?vue&type=style&index=0&id=7337fc36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7337fc36",
  null
  
)

export default component.exports